export const estratizaColors = {
  black: "#050505",
  blackSoft: "#0B0B0A",
  graphite: "#14130F",
  graphiteElevated: "#1D1A12",
  gold: "#D4AF37",
  goldLight: "#F2D675",
  goldDark: "#9B7118",
  champagne: "#FFF1B8",
  bronze: "#745016",
  ivory: "#F8F3E7",
  ivorySoft: "#EFE7D4",
  ink: "#1B170D",
  mutedLight: "#756B56",
  mutedDark: "#B8AA88",
};

export const estratizaGradients = {
  sidebar: "linear-gradient(180deg, #020202 0%, #090806 54%, #100C04 100%)",
  topbar: "linear-gradient(105deg, #030303 0%, #0B0A07 58%, #181104 100%)",
  gold: "linear-gradient(135deg, #F2D675 0%, #D4AF37 48%, #9B7118 100%)",
  goldSoft:
    "linear-gradient(135deg, rgba(242,214,117,0.20) 0%, rgba(212,175,55,0.08) 100%)",
  obsidianCard: "linear-gradient(145deg, #16140F 0%, #090909 100%)",
  darkCanvas:
    "radial-gradient(circle at 12% 0%, rgba(212,175,55,0.12), transparent 28%), #080806",
  lightCanvas:
    "radial-gradient(circle at 10% 0%, rgba(212,175,55,0.16), transparent 32%), linear-gradient(180deg, #FBF8F0 0%, #F3EDDF 100%)",
};
